<div class="screen">
    <h2 class="uk-text-center page-heading">LOB Management</h2>

    <div class="select-container">
        <select class="lobSelector custom-select" [(ngModel)]="lobSelected"  (ngModelChange)="changeLOB(lobSelected)">
            <option selected disabled hidden>Select LOB</option>
            <option *ngFor = "let lob of lobs" [ngValue]="lob[1]">{{lob[0]}}</option>
        </select>
    </div>
    <br>

    <!--name-->
    <ng-template let-element #queueName>
        <app-combo-box 
        [(value)]="element.queueName"
        (valueChange)="formValid = validate(element);"
        (valueSelect)="setUndefinedQueueArn($event, element); formValid = validate(element);" 
        [options]="queueNameOptions"
        [disabled]="false">
        </app-combo-box>
    </ng-template>

    <!--ARN-->
    <ng-template let-element #queueArn>
        <input name="arn" class="d-form" placeholder="Queue Arn" type="text" [(ngModel)]="element.queueConfig.arn" (focusout)="formValid = validate(element)">
    </ng-template>
    
    <!--Lang-->
    <ng-template let-element #language>
        <select class="small" [(ngModel)]="element.language" (ngModelChange)="formValid = validate(element)">
            <option *ngFor = "let language of languages" [ngValue]="language[1]">{{language[0]}}</option>
        </select>
    </ng-template>

    <!--whisper-->
    <ng-template let-element #whisper>
        <input name="whisper" class="d-form" placeholder="Whisper" type="text" [(ngModel)]="element.queueConfig.agentWhisper" (focusout)="formValid = validate(element)">
    </ng-template>

    <!--voicemail-->
    <ng-template let-element #voicemail>
        <input 
            name="voicemail" 
            class="d-form" 
            placeholder="+12345678910" 
            type="text" 
            [(ngModel)]="element.queueConfig.voiceMail" 
            (ngModelChange)="element.queueConfig.voiceMail = cleanPhoneNumber(element.queueConfig.voiceMail); formValid = validate(element);"
        >
    </ng-template>      

    <!--overflow behavior-->
    <ng-template let-element #overflowBehavior>
        <select class="custom-select" [(ngModel)]="overFlowSelect" (ngModelChange)="setOverFlow(element);" (focusout)="formValid = validate(element)">
            <option selected hidden ngValue="default">
                <span *ngIf="!element.queueConfig.overFlow.behavior">None</span>
                <span *ngIf="element.queueConfig.overFlow.behavior">{{element.queueConfig.overFlow.behavior}}</span>
            </option>
            <option ngValue="none">None</option>
            <option ngValue="transfer">Transfer</option>
            <option ngValue="queue">Queue</option>
        </select>
    </ng-template>

    <!--overflow queue-->
    <ng-template let-element #overflowQueue>
        <select *ngIf="element.queueConfig.overFlow.arn != null" class="small" [(ngModel)]="element.queueConfig.overFlow.arn" (focusout)="formValid = validate(element)">
            <option *ngFor = "let q of getOverflowList(element.queueId)" [ngValue]="q.queueConfig.arn">{{q.queueName}}</option>
        </select>
    </ng-template>

    <!--transfer-->
    <ng-template let-element #transfer>
        <input 
        *ngIf="element.queueConfig.overFlow.transferNumber != null"
        name="transferNumber"
        class="d-form"
        placeholder="+12345678910" 
        type="text" 
        [(ngModel)]="element.queueConfig.overFlow.transferNumber"
        (ngModelChange)="element.queueConfig.overFlow.transferNumber = cleanPhoneNumber(element.queueConfig.overFlow.transferNumber); formValid = validate(element);">
    </ng-template>

    <!--Location-->
    <ng-template let-element #location>
        <input name="location" class="d-form" placeholder="Location" type="text" [(ngModel)]="element.location" (focusout)="formValid = validate(element)">
    </ng-template>

    <!--Subunit-->
    <ng-template let-element #subunit>
        <input name="subunit" class="d-form" placeholder="SubUnit" type="text" [(ngModel)]="element.subunit" (focusout)="formValid = validate(element)">
    </ng-template>


    <div fxLayout="row" fxLayout.lt-xl="column" fxLayoutGap="10px" fxLayoutAlign="center" [hidden]="lobSelected == 'Select LOB'">
        
        <div class="tablePane">
            <h3 class="page-subheading" >Queue</h3>

            <app-response-text
                class="uk-text-center"
                [lambdaMessage]="lambdaMessage"
                [lambdaError]="lambdaError"
                >
            </app-response-text>
            <br>

            <app-mat-data-grid 
                class="page-data-grid"
                [formValid] = "formValid"
                [(dataSource)]="data" 
                [displayedColumns]="[
                    'queueName', 
                    'queueConfig.arn', 
                    'language', 
                    'queueConfig.agentWhisper', 
                    'queueConfig.voiceMail', 
                    'queueConfig.overFlow.behavior', 
                    'queueConfig.overFlow.arn', 
                    'queueConfig.overflow.transferNumber', 
                    'location', 
                    'subunit' 
                ]"   
                [columnNames]="[
                    'Queue Name', 
                    'Queue ARN', 
                    'Language', 
                    'Whisper', 
                    'Voicemail', 
                    'Overflow Behavior', 
                    'Overflow Queue Name', 
                    'Transfer To', 
                    'Location', 
                    'Subunit'
                ]"
                [editDefinition]="{
                    'queueName': queueName, 
                    'queueConfig.arn': queueArn, 
                    'language': language, 
                    'queueConfig.agentWhisper': whisper, 
                    'queueConfig.voiceMail': voicemail, 
                    'queueConfig.overFlow.behavior': overflowBehavior, 
                    'queueConfig.overFlow.arn': overflowQueue, 
                    'queueConfig.overflow.transferNumber': transfer, 
                    'location': location, 
                    'subunit': subunit 
                }"
                [pageSizeOptions] = "[5, 10, 15]"
                [buttonConfig]="{
                    create: {show: true, funcEnabled: true}
                }"
                [objectBluePrint]="bluePrint"
                (buttonClick)="onButtonEvent($event); lambdaMessage=''; lambdaError=false; overFlowSelect='default';">
            </app-mat-data-grid>

            <!-- <app-data-grid 
                [(data)]="data" 
                (itemChange)="updateItem($event)"
                [(isValid)]="formValid"
                [formTemplate]="form"
                [viewTemplate]="target" 
                [columnNames]="['Queue Name', 'Queue ARN', 'Language', 'Whisper', 'Voicemail', 'Overflow Behavior', 'Overflow Queue Name', 'Transfer To', 'Location', 'Subunit']"
                [spacing]="[2, 3, 1, 2, 2, 1, 2, 2, 2, 1, 0.6]"
                [itemsPerPage]="5"
                [objectBluePrint]="bluePrint"
                (buttonEvent)="onButtonEvent($event); lambdaMessage=''; lambdaError=false; overFlowSelect='default';"
                >
        
                <ng-template #form let-queue>
                    <td>
                        <app-combo-box 
                        [(value)]="queue.queueName"
                        (valueChange)="formValid = validate(queue);"
                        (valueSelect)="setUndefinedQueueArn($event, queue); formValid = validate(queue);" 
                        [options]="queueNameOptions"
                        >
                        </app-combo-box>
                    </td>
                    <td><input name="arn" class="d-form small" placeholder="Queue Arn" type="text" [(ngModel)]="queue.queueConfig.arn" (focusout)="formValid = validate(queue)"></td>
                    <td>
                        <select class="small" [(ngModel)]="queue.language" (focusout)="formValid = validate(queue)">
                            <option *ngFor = "let language of languages" [ngValue]="language[1]">{{language[0]}}</option>
                        </select>
                    </td>
                    <td><input name="whisper" class="d-form small" placeholder="Whisper" type="text" [(ngModel)]="queue.queueConfig.agentWhisper" (focusout)="formValid = validate(queue)"></td>
                    <td><input 
                        name="voicemail" 
                        class="d-form small" 
                        placeholder="+12345678910" 
                        type="text" 
                        [(ngModel)]="queue.queueConfig.voiceMail" 
                        (ngModelChange)="queue.queueConfig.voiceMail = cleanPhoneNumber(queue.queueConfig.voiceMail); formValid = validate(queue);"></td>                        
                    <td>
                        <select class="small" [(ngModel)]="overFlowSelect" (ngModelChange)="setOverFlow(queue);" (focusout)="formValid = validate(queue)">
                            <option selected hidden ngValue="default">
                                <span *ngIf="!queue.queueConfig.overFlow.behavior">None</span>
                                <span *ngIf="queue.queueConfig.overFlow.behavior">{{queue.queueConfig.overFlow.behavior}}</span>
                            </option>
                            <option ngValue="none">None</option>
                            <option ngValue="transfer">Transfer</option>
                            <option ngValue="queue">Queue</option>
                        </select>
                    </td>
                    <td>
                        <select *ngIf="queue.queueConfig.overFlow.arn != null" class="small" [(ngModel)]="queue.queueConfig.overFlow.arn" (focusout)="formValid = validate(queue)">
                            <option *ngFor = "let q of getOverflowList(queue.queueId)" [ngValue]="q.queueConfig.arn">{{q.queueName}}</option>
                        </select>
                    </td>
                    <td>
                        <input 
                        *ngIf="queue.queueConfig.overFlow.transferNumber != null"
                        name="transferNumber"
                        class="d-form small"
                        placeholder="+12345678910" 
                        type="text" 
                        [(ngModel)]="queue.queueConfig.overFlow.transferNumber"
                        (ngModelChange)="queue.queueConfig.overFlow.transferNumber = cleanPhoneNumber(queue.queueConfig.overFlow.transferNumber); formValid = validate(queue);">
                    </td>
                    <td><input name="location" class="d-form small" placeholder="Location" type="text" [(ngModel)]="queue.location" (focusout)="formValid = validate(queue)"></td>
                    <td><input name="subunit" class="d-form small" placeholder="SubUnit" type="text" [(ngModel)]="queue.subunit" (focusout)="formValid = validate(queue)"></td>
                </ng-template>
            
                    <ng-template #form let-queue>
                        <td>
                            <app-combo-box 
                            [(value)]="queue.queueName"
                            (valueChange)="formValid = validate(queue);"
                            (valueSelect)="setUndefinedQueueArn($event, queue); formValid = validate(queue);" 
                            [options]="queueNameOptions"
                            [disabled]="false">
                            </app-combo-box>
                        </td>
                        <td><input name="arn" class="d-form" placeholder="Queue Arn" type="text" [(ngModel)]="queue.queueConfig.arn" (focusout)="formValid = validate(queue)"></td>
                        <td>
                            <select [(ngModel)]="queue.language" (focusout)="formValid = validate(queue)">
                                <option *ngFor = "let language of languages" [ngValue]="language[1]">{{language[0]}}</option>
                            </select>
                        </td>
                        <td><input name="whisper" class="d-form" placeholder="Whisper" type="text" [(ngModel)]="queue.queueConfig.agentWhisper" (focusout)="formValid = validate(queue)"></td>
                        <td><input 
                            name="voicemail" 
                            class="d-form" 
                            placeholder="+12345678910" 
                            type="text" 
                            [(ngModel)]="queue.queueConfig.voiceMail" 
                            (ngModelChange)="queue.queueConfig.voiceMail = cleanPhoneNumber(queue.queueConfig.voiceMail); formValid = validate(queue);"></td>                        
                        <td>
                            <select class="custom-select" [(ngModel)]="overFlowSelect" (ngModelChange)="setOverFlow(queue);" (focusout)="formValid = validate(queue)">
                                <option selected hidden ngValue="default">
                                    <span *ngIf="!queue.queueConfig.overFlow.behavior">None</span>
                                    <span *ngIf="queue.queueConfig.overFlow.behavior">{{queue.queueConfig.overFlow.behavior}}</span>
                                </option>
                                <option ngValue="none">None</option>
                                <option ngValue="transfer">Transfer</option>
                                <option ngValue="queue">Queue</option>
                            </select>
                        </td>
                        <td>
                            <select *ngIf="queue.queueConfig.overFlow.arn != null" [(ngModel)]="queue.queueConfig.overFlow.arn" (focusout)="formValid = validate(queue)">
                                <option *ngFor = "let q of getOverflowList(queue.queueId)" [ngValue]="q.queueConfig.arn">{{q.queueName}}</option>
                            </select>
                        </td>
                        <td>
                            <input 
                            *ngIf="queue.queueConfig.overFlow.transferNumber != null"
                            name="transferNumber"
                            class="d-form"
                            placeholder="+12345678910" 
                            type="text" 
                            [(ngModel)]="queue.queueConfig.overFlow.transferNumber"
                            (ngModelChange)="queue.queueConfig.overFlow.transferNumber = cleanPhoneNumber(queue.queueConfig.overFlow.transferNumber); formValid = validate(queue);">
                        </td>
                        <td><input name="location" class="d-form" placeholder="Location" type="text" [(ngModel)]="queue.location" (focusout)="formValid = validate(queue)"></td>
                        <td><input name="subunit" class="d-form" placeholder="SubUnit" type="text" [(ngModel)]="queue.subunit" (focusout)="formValid = validate(queue)"></td>
                    </ng-template>
                

                <ng-template #target let-queue>
                    <td><span class="queueInfo">{{queue.queueName}}</span></td>
                    <td><span class="queueInfo">{{queue.queueConfig.arn}}</span></td>
                    <td>{{langMap.get(queue.language)}}</td>
                    <td>
                        <span>{{queue.queueConfig.agentWhisper}}</span>
                    </td>
                    <td>
                        <span>{{queue.queueConfig.voiceMail}}</span>
                    </td>
                    <td>
                        <span>{{queue.queueConfig.overFlow.behavior}}</span>
                    </td>
                    <td>
                        <span *ngIf="queue.queueConfig.overFlow.behavior == 'queue'">{{getQueueNameByArn(queue.queueConfig.overFlow.arn)}}</span>
                    </td>
                    <td>
                        <span>{{queue.queueConfig.overFlow.transferNumber}}</span>
                    </td>
                    <td><span *ngIf="queue.location">{{queue.location}}</span></td>
                    <td><span *ngIf="queue.subunit">{{queue.subunit}}</span></td>
                </ng-template>
            
            </app-data-grid> -->
        </div>   

        <div class="componentPane">
            <h3 class="page-subheading uk-text-center">Group</h3>
            
            <app-response-text
                class="uk-text-center"
                [lambdaMessage]="lambdaMessage2"
                [lambdaError]="lambdaError2"
                >
            </app-response-text>
            <br>

            <app-group-editor
                [LOB]="lobSelected"
                [groupData]="groups"
                [queueData]="data"
                (onGroupChange)="updateGroup($event)"
                (onQueueChange)="updateItem($event)"
                (onButtonClick)="lambdaMessage2=''; lambdaError2=false;"
                >
            </app-group-editor>

        </div> 
    </div>
</div>
